import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { DivButton } from '@/components/divButton';
import OutsideClickWrapper from '@/components/OutsideClickWrapper';
import Typography from '@/components/typography';
import { INSIGHTS_CATALOG_NEW_LAYER_URL } from '@/constants/urls';
import { ToolMenu } from '@/features/toolbar/constants';
import { useToolbarContext } from '@/features/toolbar/provider';
import { useAuth } from '@/providers/auth-provider';
import { setUploadFile } from '@/redux/slices/settingsSlice';

export const UploadMenu = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { isAnonymous } = useAuth();

  const { resetToDefaultTool } = useToolbarContext();

  const memoizedMenuItems = useMemo(() => {
    return [
      {
        disabledTooltip: 'Log In to Access',
        isDisabled: isAnonymous,
        label: 'Boundaries',
        onItemClick: () => {
          dispatch(setUploadFile(true));
          resetToDefaultTool();
        },
        parent: ToolMenu.Upload,
      },
      {
        label: 'Data Layer',
        onItemClick: () => {
          router.push(INSIGHTS_CATALOG_NEW_LAYER_URL);
          resetToDefaultTool();
        },
        parent: ToolMenu.Upload,
      },
    ].map(({ label, onItemClick, isDisabled, disabledTooltip }) => (
      <DivButton
        key={label}
        className="flex w-full items-center justify-center py-2 pl-2 hover:bg-gray-80"
        data-tooltip-content={isDisabled ? disabledTooltip : ''}
        data-tooltip-place="bottom"
        disabled={isDisabled}
        onClick={onItemClick}
      >
        <div className="flex flex-grow items-center justify-center pl-2">
          <Typography variant="body2">{label}</Typography>
        </div>
      </DivButton>
    ));
  }, [dispatch, isAnonymous, router, resetToDefaultTool]);

  return (
    <OutsideClickWrapper
      onOutsideClick={() => {
        resetToDefaultTool();
      }}
    >
      <div
        className={twMerge(
          'w-[160px] overflow-hidden bg-gray-90 text-white transition-all ease-in-out'
        )}
      >
        {memoizedMenuItems}
      </div>
    </OutsideClickWrapper>
  );
};
